import { render, staticRenderFns } from "./ContentNotice.vue?vue&type=template&id=7fbe2c9e&scoped=true&"
import script from "./ContentNotice.vue?vue&type=script&lang=js&"
export * from "./ContentNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbe2c9e",
  null
  
)

export default component.exports